import React, { useEffect, useState } from 'react';
import i18n from 'utils/I18n';
import { getBaseFormattedDate, getMyAccountUserBirthdayForDisplay } from 'utils/DateTimeUtils';
import ConfirmField from './ConfirmField';
import MonthPicker, { CustomDatePickerInput } from 'component/date_picker/MonthPicker';
import CustomDatePicker from 'component/date_picker/CustomDatePicker';

const OtherInfoDatetimeField = ({
  language,
  question = {},
  isConfirm,
  editAction,
}) => {
  const {
    placeholder,
    defaultValue,
    fieldName,
    precision,
  } = question;

  const [showModal, setShowModal] = useState(false);
  const [inputValue, setInputValue] = useState(defaultValue);
  useEffect(() => {
    setInputValue(defaultValue);
  }, [defaultValue]);

  const getDisplayValue = (value) => {
    if (precision === 'month') {
      return getMyAccountUserBirthdayForDisplay(value)
    }
    return getBaseFormattedDate(value)
  }

  const onEdit = (value) => {
    editAction(fieldName, value);
  };

  if (isConfirm) {
    return (
      <ConfirmField
        value={
          inputValue
            ? getDisplayValue(inputValue)
            : i18n.t('not_provided')
        }
      />
    )
  }

  return (
    <div className="common-item-value field-text">
      {
        precision === 'month'
          ? <>
            <CustomDatePickerInput
              placeholder={placeholder}
              value={inputValue ? getMyAccountUserBirthdayForDisplay(inputValue) : null}
              onClick={() => {
                setShowModal(!showModal);
              }}
              showBirthMonthOptions={showModal}
            />
            <MonthPicker
              customClassName="ticket_other_info_month_picker"
              show={showModal}
              lang={i18n.language}
              selected={inputValue}
              onChange={(date) => {
                if (!!date) {
                  onEdit(date);
                }
                setShowModal(false);
              }}
            />
          </>
          : <CustomDatePicker
            language={language}
            selectedDate={inputValue}
            onSelected={(date) => {
                onEdit(date);
            }}
            placeholder={placeholder}
          />
      }
    </div>
  );
};

export default OtherInfoDatetimeField;
